/**
 * This file gets location from geo location
 * @todo: Read from geo location once its available in wordpress.
 */
import { GetZipCode as GetZipCodeFromService, GetIpAddress as GetIpAddressFromService } from '~/services/geo-location';

export default {
    methods: {
        GetZipCode(zip, callBackFunction) {
            if (typeof callBackFunction !== 'function') {
                return;
            }
            GetZipCodeFromService(zip).then((response) => {
                callBackFunction(response);
            });
        },
        GetIpAddress(callBackFunction) {
            if (typeof callBackFunction !== 'function') {
                return;
            }
            GetIpAddressFromService().then((response) => {
                if (response?.ipAddress) {
                    callBackFunction(response);
                } else {
                    callBackFunction(null);
                }
            }, (error) => {
                callBackFunction(error);
            });
        },
    },
    created() {
        if (this.ZipCode && this.ZipCode !== '') this.GetZipCode(this.ZipCode, this.updateLocation);
        else this.GetIpAddress(this.updateLocation);
    },
};
